/**
 * RSS feed loading progress for Industry News progressive fetch.
 */

export interface RssFeedLoadProgressInput {
  feedsLoadedCount: number;
  totalFeedCount: number;
  isLoadingFeeds: boolean;
}

export interface RssFeedLoadProgress {
  feedsLoadedCount: number;
  totalFeedCount: number;
  isLoadingFeeds: boolean;
  allFeedsLoaded: boolean;
  loadingMessage: string | null;
}

export function computeRssFeedLoadProgress(
  input: RssFeedLoadProgressInput
): RssFeedLoadProgress {
  const { feedsLoadedCount, totalFeedCount, isLoadingFeeds } = input;
  const allFeedsLoaded =
    totalFeedCount === 0 || (feedsLoadedCount >= totalFeedCount && !isLoadingFeeds);

  return {
    feedsLoadedCount,
    totalFeedCount,
    isLoadingFeeds,
    allFeedsLoaded,
    loadingMessage:
      isLoadingFeeds && totalFeedCount > 0
        ? `Loading feeds (${feedsLoadedCount}/${totalFeedCount})…`
        : null,
  };
}

/** @deprecated Prefer explicit feedsLoadedCount from progressive RSS hook. */
export interface LegacyRssFeedLoadProgressInput {
  selectedFeedCount: number;
  isFetching: boolean;
  isFetched: boolean;
}

export function computeLegacyRssFeedLoadProgress(
  input: LegacyRssFeedLoadProgressInput
): RssFeedLoadProgress {
  const { selectedFeedCount, isFetching, isFetched } = input;
  const allFeedsLoaded = isFetched && !isFetching;

  return computeRssFeedLoadProgress({
    feedsLoadedCount: allFeedsLoaded ? selectedFeedCount : 0,
    totalFeedCount: selectedFeedCount,
    isLoadingFeeds: isFetching,
  });
}
